<template>
  <div class="f-w f-h">
    <RouterView />
  </div>
</template>

<script>
/**
 * Ghost component for config routes
 */

export default {

  name: 'Config',

  created() {
    if (this.$route.path === '/config') {
      this.$router.push('/config/details');
    }
  },
};
</script>
